window.rechenoperation = function (element) {
	try {
		// Leerzeichen, Punkte loeschen und Kommata durch Punkte ersetzen
		let string = element.value.replace(/ /g, "")
		string = string.replace(/\./g, "")
		string = string.replace(/,/g, ".")

		const regex = /^[\d\.\+\-\*\/]+$/

		if (!regex.test(string)) throw new Error("Ungültige Eingabe")

		return eval(string)
	} catch (error) {
		console.error("Fehler beim Auswerten der Rechenoperation:", error)
		return 0
	}
}

window.currency = (number, precision = 0, show_zero = true) => {
	if (number == 0 && !show_zero) return ""
	if (number == 0 && show_zero) return "- €"

	if (number < 0) {
		return `- ${new Intl.NumberFormat("de-DE", { minimumFractionDigits: precision, maximumFractionDigits: precision }).format(Math.abs(number))} €`
	} else {
		return `${new Intl.NumberFormat("de-DE", { minimumFractionDigits: precision, maximumFractionDigits: precision }).format(number)} €`
	}
}

window.percentage = (number, precision = 0, show_zero = true) => {
	if (number == 0 && !show_zero) return ""
	// if (number == 0 && show_zero) return "- %"

	return `${new Intl.NumberFormat("de-DE", { minimumFractionDigits: precision, maximumFractionDigits: precision }).format(number)} %`
}

window.currencyStringToFloat = (currencyString) => {
	if (!currencyString) return 0
	// Entferne alle Punkte (Tausender-Trenner) aus der Zeichenkette
	// Ersetze das Komma durch einen Punkt (für die Dezimalstellen)
	let cleanString = currencyString.replace(/\./g, "").replace(",", ".").replace(/ /g, "")

	// Konvertiere die bereinigte Zeichenkette in einen Float-Wert
	let floatValue = parseFloat(cleanString)
	// Überprüfe, ob die Konvertierung erfolgreich war
	if (isNaN(floatValue)) {
		return 0
		// throw new Error("Ungültiger Euro-Betrag")
	}
	return floatValue
}
